import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@govard/i18n-core/react';

export default function NotFoundPage(): ReactElement {
  const { t } = useTranslation();

  return (
    <main
      className="animate-fade-in flex min-h-screen items-center justify-center p-6"
      style={{ backgroundColor: 'var(--color-bg, #fcfaf8)' }}
    >
      <div 
        className="card flex w-full max-w-md flex-col"
        style={{ padding: 32 }}
      >
        <div className="mb-6">
          <h1 className="font-bold tracking-tight" style={{ fontSize: 24, color: 'var(--color-text, #2d2418)' }}>
            {t('crm.not_found.title')}
          </h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-muted, #a89b8a)', marginTop: 4 }}>
            {t('crm.not_found.description')}
          </p>
        </div>
        
        <div className="flex flex-col gap-3 mt-2 sm:flex-row">
          <Link data-testid="not-found-home" to="/dashboard" className="btn btn-primary" style={{ fontSize: 13, flex: 1, textAlign: 'center', justifyContent: 'center' }}>
            {t('crm.not_found.home')}
          </Link>
          <Link data-testid="not-found-login" to="/login" className="btn btn-light" style={{ fontSize: 13, flex: 1, textAlign: 'center', justifyContent: 'center' }}>
            {t('crm.not_found.login')}
          </Link>
        </div>
      </div>
    </main>
  );
}
